import { render, staticRenderFns } from "./honorCard.vue?vue&type=template&id=12094ea6&scoped=true&"
import script from "./honorCard.vue?vue&type=script&lang=js&"
export * from "./honorCard.vue?vue&type=script&lang=js&"
import style0 from "./honorCard.vue?vue&type=style&index=0&id=12094ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12094ea6",
  null
  
)

export default component.exports